import React, { useEffect, useState, useRef } from 'react';
import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import { Drawer, Form, message, Row, Col, Spin, Space, Input } from 'antd';
import { AddUser } from '../style';
import { BasicFormWrapper } from '../../styled';
import { SaveApprovalQueue, QueueDetails, deleteRequestId, addCommentsForApprovalProcess } from '../../../Api/Services/ApprovalApiService';
import { FetchAllContactByCompany } from '../../../Api/Services/ContactApiService';
import { FetchAllAccountType, FetchAllOwnership, FetchAllCustomerstatus, FetchAllAccount } from '../../../Api/Services/AccountApiService'
import { FetchAllPipeline, DealTypeAPi, PriorityDealApi, wonReasonApi, LostReasonApi, HoldReasonapi, FetchAllDeal } from '../../../Api/Services/DealApiService'
import { getCountryData, getTriggerFiledforEntity, IndustryData, getLeadsourceData, getLeadStatusData, getSeniorityLevelData, getTitle, getAnnualRevenue, getNoofEmployee, getRating, getAllUsersData } from '../../../Api/Services/CommonApiService'
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import { ExchangeCurrency } from '../Filters/FilterConditions';
import ConfirmationPopup from '../Popup/ConfirmationPopup'
import { CancelIcon } from '../../../components/Icons/Icons'
import { validateDescriptionField } from '../../../components/utilities/utilities';

const Popup = ({ popup, setPopup, popupId, setPopupId, popupPage, setPopupPage, MyList, SharedList, detailsId, currencySettingsRef }) => {
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const [form] = Form.useForm();
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const [doubleClick1, setDoubleClick1] = useState(false)
    const [doubleClick2, setDoubleClick2] = useState(false)
    const [disabled, setDisbled] = useState(false)
    const [acceptList, setAcceptList] = useState([])
    const [detailsData, setDetailsData] = useState()
    const [approverStatus, setApproverStatus] = useState()
    const [confirmPopup, setConfirmPopup] = useState(false)
    const [displayItems, setdisplayItems] = useState(false)
    const [deleteId, setDeleteId] = useState()
    const [currentData, setcurrentData] = useState()
    const [proposedData, setProposedData] = useState()
    const [entityData, setEntityData] = useState()
    const [pendingList, setPendingList] = useState([])
    const [notes, setNotes] = useState();
    const [allNotes, setAllNotes] = useState([]);
    const convertTime = (timeStr, timeFormat) => {
        let hours;
        let minutes;
        // let seconds;
        let period;
        if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
            // Parse 12-hour time string
            const timeParts = timeStr.match(/(\d{1,2}):(\d{2}):?(\d{2})?/);
            hours = parseInt(timeParts[1], 10);
            minutes = parseInt(timeParts[2], 10);
            // seconds = parseInt(timeParts[3], 10);
            period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

            if (period === 'pm' && hours !== 12) {
                hours += 12;
            } else if (period === 'am' && hours === 12) {
                hours = 0;
            }
        } else {
            // Parse 24-hour time string
            const timeParts = timeStr.split(':');
            hours = parseInt(timeParts[0], 10);
            minutes = parseInt(timeParts[1], 10);
            // seconds = parseInt(timeParts[2], 10);
        }
        if (timeFormat === '12hrs' || timeFormat === '12-hour') {
            period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} ${period}`;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
        }
        // No need for an else here because we return in the if above
        if (timeFormat === '24hrs' || timeFormat === '24-hour') {
            // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        }
        throw new Error('Invalid time format specified');
    };
    function convertAndFormatDateTime2(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const formattedDate = converted.format(dateFormat);
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat);

        return `${formattedDate} ${formattedTime}`
    }
    function getCurrentDateTimeFromZoneString(tzStr) {
        if (!tzStr) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const timezone = extractTimezoneName(tzStr)
        if (!moment.tz.zone(timezone)) {
            console.warn("Invalid timezone:", timezone);
            return "";
        }
        return moment.tz(timezone).format("YYYY-MM-DD HH:mm");
    }
    const getemailopt = async () => {
        try {
            const construct = [
                { value: 1, label: "True" },
                { value: 0, label: "False" },
                { value: true, label: "True" },
                { value: false, label: "False" }
            ]
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getcommitStatus = async () => {
        try {
            const construct = [
                { value: "Hard Commit", label: "Hard Commit" },
                { value: "Soft Commit", label: "Soft Commit" }
            ]
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getdealsubtype = async () => {
        try {
            const construct = [
                { value: "Request for Proposal", label: "Request for Proposal" },
                { value: "Staff Augmentation", label: "Staff Augmentation" },
                { value: "Product and Services", label: "Product and Services" },
                { value: "Others", label: "Others" }
            ]
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getAllAccounts = async () => {
        try {
            const response = await FetchAllAccount()
            const construct = response.map((item, key) => ({
                index: key,
                value: item.account_id,
                label: item.account_name
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    async function getAllDeal() {
        try {
            const response = await FetchAllDeal()
            const construct = response.map((item, key) => ({
                index: key,
                value: item.deals_id,
                label: item.deal_name
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getCountry = async () => {
        try {
            const data = await getCountryData()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.country,
                label: item.country
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getLeadsource = async () => {
        try {
            const data = await getLeadsourceData()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.leadSourceId,
                label: item.leadSourceName
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getSeniorityLevel = async () => {
        try {
            const data = await getSeniorityLevelData()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.seniorityLevelId,
                label: item.seniorityLevel
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getLeadStatus = async () => {
        try {
            const data = await getLeadStatusData()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.leadStatusId,
                label: item.leadStatusName
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getIndustry = async () => {
        try {
            const data = await IndustryData()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.industryId,
                label: item.industryName
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getTitleData = async () => {
        try {
            const data = await getTitle()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.title,
                label: item.title
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getAnnualRevenueData = async () => {
        try {
            const data = await getAnnualRevenue()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.annualRevenue,
                label: item.annualRevenue
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getRatingData = async () => {
        try {
            const data = await getRating()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.rating,
                label: item.rating
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getNomEmployeeData = async () => {
        try {
            const data = await getNoofEmployee()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.nomOfEmployee,
                label: item.nomOfEmployee
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getAllAccountType = async () => {
        try {
            const data = await FetchAllAccountType()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.accountTypeId,
                label: item.accountTypeName
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getAllOwnership = async () => {
        try {
            const data = await FetchAllOwnership()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.ownershipId,
                label: item.ownershipName
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getPipelineData = async () => {
        try {
            const data = await FetchAllPipeline()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.pipelineStageId,
                label: item.pipelineStageName
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getAllCustomerstatus = async () => {
        try {
            const data = await FetchAllCustomerstatus()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.customerStatus,
                label: item.customerStatus
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const getAllContact = async () => {
        try {
            const data = await FetchAllContactByCompany()
            const construct = data?.items.map((item, key) => ({
                index: key,
                value: item.contactsId,
                label: `${item.firstName} ${item.lastName}`
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const GetPriorityDealApi = async () => {
        try {
            const data = await PriorityDealApi()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.priorityId,
                label: item.priorityName
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const GetwonReasonApi = async () => {
        try {
            const data = await wonReasonApi()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.dealWonReasonId,
                label: item.dealWonReasonName
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const GetHoldReasonapi = async () => {
        try {
            const data = await HoldReasonapi()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.dealHoldReasonId,
                label: item.dealOnHoldReasonName
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const GetLostReasonApi = async () => {
        try {
            const data = await LostReasonApi()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.dealLostReasonId,
                label: item.dealLostReasonName
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    const GetDealTypeAPi = async () => {
        try {
            const data = await DealTypeAPi()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.dealTypeId,
                label: item.dealTypeName
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const construct = data.map((item, key) => ({
                index: key,
                value: item.userId,
                label: `${item.firstName}${item.lastName ? ` ${item.lastName}` : ""}`
            }));
            return construct
        }
        catch (error) {
            message.error(error)
            return []
        }
    };
    const FIELD_API_MAP = {
        leadOwner: UserDetailsApi, leadSourceId: getLeadsource, leadStatusId: getLeadStatus, seniorityLevelId: getSeniorityLevel, title: getTitleData,
        annualRevenue: getAnnualRevenueData, industry: getIndustry, nomOfEmployees: getNomEmployeeData, rating: getRatingData, country: getCountry,
        contactSourceId: getLeadsource, reportingTo: getAllContact, parentOrganization: getAllAccounts, accountType: getAllAccountType,
        ownership: getAllOwnership, accountOwner: UserDetailsApi, customerStatus: getAllCustomerstatus, dealOwner: UserDetailsApi,
        subtype: getdealsubtype, dealType: GetDealTypeAPi, dealLostReason: GetLostReasonApi, dealWonReason: GetwonReasonApi, accountName: getAllAccounts,
        dealHoldReason: GetHoldReasonapi, commitStatus: getcommitStatus, emailOtpOut: getemailopt, emailOptOut: getemailopt, accountId: getAllAccounts, parentDeaName: getAllDeal,
        pipelineStage: getPipelineData, contactPerson: getAllContact,
        priority: GetPriorityDealApi, competition: getAllAccounts,
    }
    const setProjectNotesData = (value) => {
        if (value.comments && value.comments !== '[]' && value.comments !== '') {
            setAllNotes(value.comments);
        } else {
            setAllNotes([]);
        }
    };
    async function getNotesonly(id) {
        try {
            const response = await QueueDetails(id);
            setProjectNotesData(response.data);
        } catch (error) {
            message.error(error);
        }
    }
    function convertDateFromCompany(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const currentTimeInProfile = moment.tz(fromTimezone).format("HH:mm");
        const dateWithTime = moment.tz(
            `${dateTime} ${currentTimeInProfile}`,
            "YYYY-MM-DD HH:mm",
            fromTimezone
        );
        const converted = dateWithTime.clone().tz(toTimezone);
        const formattedDate = converted.format("YYYY-MM-DD");
        return formattedDate
    }
    const handleAddNote = async () => {
        let hideMessage;
        const data = {
            id: profile.userId,
            name: `${profile.firstName} ${profile.lastName}`,
            time: getCurrentDateTimeFromZoneString(companyProfile?.timeZone),
            content: notes,
        };
        setAllNotes((prevNotes) => [data, ...prevNotes]);
        setNotes('');
        const NewNotes = [data, ...allNotes]
        const formData = {
            comments: NewNotes,
        };
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await addCommentsForApprovalProcess(formData, detailsId)
            if (response.status === 200) {
                hideMessage();
                message.success("Comment added")
                getNotesonly(detailsId)
            }
            setNotes('');
        } catch (error) {
            hideMessage();
            message.error(error)
        }
    };
    const NoteDelete = async (id) => {
        let hideMessage;
        const updatedFormData = [...allNotes];
        updatedFormData.splice(id, 1);
        setAllNotes(updatedFormData);
        const formData = {
            comments: updatedFormData,
        };
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await addCommentsForApprovalProcess(formData, detailsId)
            if (response.status === 200) {
                hideMessage();
                message.success("Comment removed")
                getNotesonly(detailsId)
            }
            setNotes('');
        } catch (error) {
            hideMessage();
            message.error(error)
        }
    }
    const handleClose = () => {
        setPopup(false)
        setPopupId()
        setPopupPage()
    }
    const getOriginalApprovers = (approvedList) => {
        // Step 1: Group data by approvalStage
        const groupedByStage = approvedList.reduce((acc, item) => {
            const stage = item.approvalStage;
            if (!acc[stage]) {
                acc[stage] = [];
            }
            acc[stage].push(item);
            return acc;
        }, {});

        // Step 2: Find the original approver for each stage
        const originalApprovers = Object.values(groupedByStage).map(stageGroup => {
            const approvedById = stageGroup[0].approvedBy; // Assuming the first entry contains the approvedBy ID
            return stageGroup.find(person => person.approver === approvedById) || null;
        }).filter(Boolean); // Remove null values if no match is found

        return originalApprovers;
    };
    const formatData = (list) => {
        return list.map((item, index) => ({
            approvalStage: index + 1,
            approvers: `${item.approvarFirstName} ${item.approvarLastName}`,
            approvalStatus: item.approvalStatus,
        }));
    };
    const groupByStage = (list) => {
        return list.reduce((acc, item) => {
            const stage = item.approvalStage;
            const name = `${item.approvarFirstName} ${item.approvarLastName}`;
            if (!acc[stage]) {
                acc[stage] = [];
            }
            acc[stage].push(name);
            return acc;
        }, {});
    };
    async function deleteMenu(id) {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick2(true)
        let hideMessage;
        setDisbled(true)
        try {
            hideMessage = message.loading("Loading...", 0);
            const Response = await deleteRequestId(id)
            if (Response.status === 200) {
                hideMessage()
                // if (type === "Fromqueue") {
                MyList()
                SharedList()
                // }
                setDisbled(false)
                setPopup(false)
                setPopupId()
                setPopupPage()
                message.success("Request deleted")
                loadingRef.current = false;
                setDoubleClick2(false)
            }
        }
        catch (error) {
            hideMessage()
            setDisbled(false)
            message.error(error)
            loadingRef.current = false;
            setDoubleClick2(false)
        }
    }
    const filterEditedFields = async (fullArray, editedFieldsArray) => {
        if (!fullArray || !editedFieldsArray) return [];
        return fullArray.filter(item =>
            editedFieldsArray.some(edited => edited.editedField === item.filedValue)
        );
    };
    const extractAttributes = async (DataArray, RecordData, OldData) => {
        if (!DataArray || !RecordData || !OldData) return { selectedAttributes: [], oldAttributes: [] };
        const selectedAttributes = DataArray.reduce((acc, item) => {
            if (Object.keys(RecordData).includes(item.filedValue)) {
                acc.push({
                    ...item,
                    attributevalue: RecordData[item.filedValue]
                });
            }
            return acc;
        }, []);
        const oldAttributes = selectedAttributes.map(attr => ({
            ...attr,
            attributevalue: OldData[attr.filedValue] || null
        }));
        return { selectedAttributes, oldAttributes };
    };
    const extractAttributesforCreate = async (DataArray, RecordData) => {
        if (!DataArray || !RecordData) return { selectedAttributes: [] };
        const selectedAttributes = DataArray.reduce((acc, item) => {
            if (Object.keys(RecordData).includes(item.filedValue)) {
                acc.push({
                    ...item,
                    attributevalue: RecordData[item.filedValue]
                });
            }
            return acc;
        }, []);
        return { selectedAttributes };
    };
    function cleanObject(obj) {
        return Object.fromEntries(
            Object.entries(obj).filter(([, value]) => value !== "" && value !== null && value !== undefined)
        );
    }
    const getDropdownLabel = async (fieldValue, value, entity) => {
        if (entity === "Lead" && fieldValue === "accountName") {
            return value;
        }
        if (fieldValue === "emailOtpOut" || fieldValue === "emailOptOut") {
            if (value === undefined || value === null || value === "") return "-";
        }
        else if (fieldValue !== "emailOtpOut" && fieldValue !== "emailOptOut") {
            if (!value || value === "") return "-";
        }
        const api = FIELD_API_MAP[fieldValue];
        if (!api) return value;
        const options = await api();
        if (!options) return value;
        if (fieldValue === "contactPerson" || fieldValue === "competition") {
            const valuesArray = value.includes(",") ? value.split(",") : [value];
            return valuesArray
                .map(val => {
                    const numVal = Number(val.trim());
                    const matchedOption = options.find(option => option.value === numVal) ?? { label: '-' };;
                    return matchedOption.label
                })
                .join(", ");
        }
        const matchedOption = options.find(option => option.value === value) ?? { label: '-' };
        return matchedOption.label
    };
    const formatDate = async (dateValue) => {
        if (!dateValue || dateValue === "") return "-";
        const dateFormat = (profile.dateFormate && profile.dateFormate !== "") ? profile.dateFormate : "YYYY-MM-DD"
        return moment(dateValue).format(dateFormat)
    };
    const formatCurrency = async (value) => {
        const ConvertRates = currencySettingsRef?.exchangeRate;
        const CurencyDecimalPlace = currencySettingsRef?.decimalOfCurrency;
        if (!value || value === "") return "-";
        const convertedValue = await ExchangeCurrency(Number(value), ConvertRates)
        return `${currencySettingsRef?.symbol} ${Number(convertedValue?.toFixed(CurencyDecimalPlace)).toLocaleString()}`
    };
    const processAttributeValue = async (item, entity) => {
        if (item.FieldType === "Drop Down") {
            const formateValue = await getDropdownLabel(item.filedValue, item.attributevalue, entity, entity);
            return formateValue;
        }
        if (item.FieldType === "Date") {
            const formatevalue = await formatDate(item.attributevalue);
            return formatevalue;
        }
        if (item.currencyType === "YES") {
            const formatedValue = await formatCurrency(item.attributevalue)
            return formatedValue;
        }
        return item.attributevalue && item.attributevalue !== "" ? item.attributevalue : "-";
    };
    const formatAttributes = async (attributes, entity) => {
        return Promise.all(
            attributes.map(async (item) => ({
                ...item,
                attributevalue: await processAttributeValue(item, entity)
            }))
        );
    };
    function sanitizeEntityData(entityData, entityType) {
        // Base fields to always remove
        const baseFieldsToRemove = [
            "approvedFor",
            "createdTime",
            "companyId",
            "createdAt",
            "createdBy"
        ];
        const conditionalRemovals = {
            Contact: ["contactsId"],
            Lead: ["leadsId"],
            Account: ["accountsId"],
            Deal: ["dealsId"]
        };
        const fieldsToRemove = [...baseFieldsToRemove];
        if (conditionalRemovals[entityType]) {
            fieldsToRemove.push(...conditionalRemovals[entityType]);
        }
        const sanitizedData = { ...entityData };
        fieldsToRemove.forEach(field => {
            delete sanitizedData[field];
        });
        return sanitizedData;
    }
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const convertQueryData = async (data, ConvertRate, CurencyDecimalPlace, setTypeing) => {
        const processItems = async (items) => {
            return Promise.all(
                items.map(async (item) => {
                    const simpleOperators = ["=", "IS", "!=", "IS NOT", "<", "IS BEFORE", ">", "IS AFTER"];
                    if (item.type === "condition") {
                        if (item.Currency === 'YES') {
                            if (item.value !== undefined && item.value !== null && item.value !== "") {
                                if (setTypeing === "Seting") {
                                    item.value = normalizeValue(item.value);
                                    const exchangedValue = await ExchangeCurrency(Number(item.value), ConvertRate);
                                    item.value = Number(exchangedValue?.toFixed(CurencyDecimalPlace));
                                }
                            }
                        }
                        if (setTypeing === "Seting") {
                            if (item.Key === 'Date') {
                                if (item.field === "created_at" || item.field === "dealCreatedAt" || item.field === 'Created Date' || item.field === "modified_at" || item.field === "Modified Date") {
                                    if (simpleOperators.includes(item.operator)) {
                                        item.value = convertDateFromCompany(item.value, profile, companyProfile)
                                    }
                                }

                            }
                        }
                    } else if (item.type === "group" && Array.isArray(item.items)) {
                        item.items = await processItems(item.items);  // Recursively process sub-items
                    }

                    return item;
                })
            );
        };
        return processItems(data);
    };
    const buildQuery = async (groupData) => {
        const CurencyDecimalPlace = currencySettingsRef?.decimalOfCurrency;
        const clausePromises = groupData.items.map(async (item, index) => {
            let clause = "";
            if (item.type === "condition") {
                if (item.operator === "IS NULL" || item.operator === "IS NOT NULL") {
                    clause = `${item.field} ${item.operator}`;
                }
                if (item.field === "Win Probability" || item.field === "Expected Deal Margin" || item.field === "Discount Percentage" || item.field === "Actual Deal Margin") {
                    clause = `${item.field} ${item.operator} % ${item.value}`;
                }
                if (item.Currency === "YES") {
                    clause = `${item.field} ${item.operator} ${currencySettingsRef?.symbol} ${Number(item.value?.toFixed(CurencyDecimalPlace)).toLocaleString()}`;
                }
                if (item.Key === "Date") {
                    const formattedValue = item.value ? await formatDate(item.value) : null;
                    clause = `${item.field} ${item.operator}${formattedValue && ` ${formattedValue}`}`;
                }
                else {
                    clause = `${item.field} ${item.operator} ${item.value}`;

                }
            } else if (item.type === "group") {
                const inner = await buildQuery(item);
                const conditionCount = item.items.filter(
                    (child) => child.type === "condition"
                ).length;
                const shouldWrap = conditionCount > 1;
                clause = shouldWrap ? `(${inner})` : inner;
                // clause = `(${inner})`;
            }
            if (index > 0 && item.relationWithPrevious) {
                clause = `${item.relationWithPrevious.toUpperCase()} ${clause}`;
            }
            return clause;
        });
        const parts = await Promise.all(clausePromises);
        return parts.join(" ");
    };
    async function getDetailsPage(id) {
        const ConvertRates = currencySettingsRef?.exchangeRate;
        const CurencyDecimalPlace = currencySettingsRef?.decimalOfCurrency;
        try {
            const newResponse = await QueueDetails(id)
            if (!newResponse.allow) throw new Error();
            const response = newResponse.data
            const copiedGroup = JSON.parse(JSON.stringify(response.approvalQuery));
            const processedItems = await convertQueryData(copiedGroup.items, ConvertRates, CurencyDecimalPlace, "Seting");
            copiedGroup.items = processedItems;
            const finalQuery = await buildQuery(copiedGroup);
            setDetailsData({
                ...response,
                approvalQuery: finalQuery,
            });
            setAllNotes(response.comments);
            const approverData = response?.approvarList.find(item => item.approver === profile?.userId);
            setApproverStatus(approverData)
            let groupedPending;
            let groupedApproved;
            if (response?.is_approves === 1) {
                const pendingList = response?.approvarList.filter(item => item.approvalStatus === "Pending");
                const approvedList = response?.approvarList.filter(item => item.approvalStatus === "Approved" || item.approvalStatus === "Rejected");
                groupedPending = Object.entries(groupByStage(pendingList)).map(([stage, names]) => ({
                    approvalStage: parseInt(stage),
                    approvers: names.join("/")
                }));
                const onlyApprovers = getOriginalApprovers(approvedList)
                groupedApproved = formatData(onlyApprovers)
            }
            if (response?.is_approves === 0) {
                const isRequire = response?.if_approve_no?.isResposeRequired;
                if (isRequire) {
                    const pendingList = response?.approvarList.filter(item => item.approvalStatus === "Pending");
                    const approvedList = response?.approvarList.filter(item => item.approvalStatus === "Approved" || item.approvalStatus === "Rejected");
                    groupedApproved = formatData(approvedList)
                    groupedPending = formatData(pendingList)
                } else {
                    const pendingList = response?.approvarList.filter(item => item.approvalStatus === "Pending");
                    const approvedList = response?.approvarList.filter(item => item.approvalStatus === "Approved" || item.approvalStatus === "Rejected");
                    const onlyApprovers = getOriginalApprovers(approvedList)
                    groupedApproved = formatData(onlyApprovers)
                    groupedPending = Object.entries(groupByStage(pendingList)).map(([stage, names]) => ({
                        approvalStage: parseInt(stage) + 1,
                        approvers: names.join("/")
                    }));
                }
            }
            setPendingList(groupedPending)
            setAcceptList(groupedApproved)
            if (response?.entityAction === "Edited" || response?.entityAction === "Deleted") {
                if (response?.entityAction === "Deleted") {
                    setEntityData(response?.entityData)
                } else {
                    setEntityData(response?.oldEntityData)
                }
                try {
                    const data = await getTriggerFiledforEntity(response?.entityType);
                    if (response?.entityAction === "Edited" && response?.recordAction?.editedType === "Any field is edited") {
                        const { selectedAttributes, oldAttributes } = await extractAttributes(data, response?.entityData, response?.oldEntityData);
                        const formatcurrent = await formatAttributes(oldAttributes, response?.entityType)
                        const formatnew = await formatAttributes(selectedAttributes, response?.entityType)
                        setcurrentData(formatcurrent);
                        setProposedData(formatnew);
                    }
                    if (response?.entityAction === "Edited" && response?.recordAction?.editedType === "Specific Field is edited") {
                        const filteredData = await filterEditedFields(data, response?.recordAction?.editedFieldCondition);
                        const { selectedAttributes, oldAttributes } = await extractAttributes(filteredData, response?.entityData, response?.oldEntityData);
                        const formatcurrent = await formatAttributes(oldAttributes, response?.entityType)
                        const formatnew = await formatAttributes(selectedAttributes, response?.entityType)
                        setcurrentData(formatcurrent);
                        setProposedData(formatnew);
                    }
                } catch (error) {
                    message.error(error);
                }

            } else {
                const cleandata = cleanObject(response?.entityData)
                const createdData = sanitizeEntityData(cleandata, response?.entityType)
                try {
                    const data = await getTriggerFiledforEntity(response?.entityType);
                    const { selectedAttributes } = await extractAttributesforCreate(data, createdData);
                    const formatnew = await formatAttributes(selectedAttributes, response?.entityType)
                    setcurrentData(formatnew);
                } catch (error) {
                    message.error(error);
                }
            }
            setdisplayItems(true)
        }
        catch (error) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    handleClose();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        if (values === "Approved") {
            setDoubleClick(true)
        } else {
            setDoubleClick1(true)
        }
        let hideMessage;
        setDisbled(true)
        try {
            hideMessage = message.loading("Processing...", 0);
            const Payload = {}
            const response = await SaveApprovalQueue(values, popupId, Payload)
            if (response.status === 201) {
                hideMessage()
                //    if (type === "Fromqueue") {
                MyList()
                SharedList()
                // }
                setDisbled(false)
                setPopup(false)
                setPopupId()
                setPopupPage()
                message.success(`Request ${values}`)
                loadingRef.current = false;
                setDoubleClick(false)
                setDoubleClick1(false)
            }
        }
        catch (error) {
            hideMessage();
            setDisbled(false)
            message.error(error)
            loadingRef.current = false;
            setDoubleClick(false)
            setDoubleClick1(false)
        }
    }
    useEffect(() => {
        if (popup) {
            if (detailsId) {
                getDetailsPage(detailsId)
            }
        }
    }, [detailsId, popup])
    const OnClickofDelete = (value) => {
        setConfirmPopup(true)
        setDeleteId(value)
    }
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                // title="Approval Request Details"
                title={
                    detailsData?.subject ? (
                        <span>
                            Approval Request Details
                            <span style={{
                                margin: '0 10px',
                                color: '#d9d9d9',
                                fontWeight: 'normal'
                            }}>|</span>
                            <span style={{ fontWeight: 'normal' }}>
                                {detailsData.subject}
                            </span>
                        </span>
                    ) : "Approval Request Details"
                }
                closable={false}
                placement="right"
                open={popup}
                width="70%"
                extra={
                    < Space >
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => handleClose()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    handleClose()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space >
                }
                footer={displayItems ? (popupPage === "Approver" ?
                    (approverStatus?.approvalStatus === "Approved" || approverStatus?.approvalStatus === "Rejected") ? false :
                        [<div className="form_action_button">
                            <Button size="small" className="button_colors" onClick={() => onSubmit("Approved")} disabled={disabled || doubleClick} loading={doubleClick}>{!doubleClick && <FeatherIcon icon="thumbs-up" />}Approve</Button>
                            <Button size="small" className="red-button" onClick={() => onSubmit("Rejected")} disabled={disabled || doubleClick1} loading={doubleClick1}>{!doubleClick1 && <FeatherIcon icon="thumbs-down" />}Reject</Button>
                        </div>] : [<div className="form_action_button">
                            <Button onClick={() => OnClickofDelete(detailsId)} className="red-button" size="small" disabled={disabled || doubleClick2} loading={doubleClick2}>{!doubleClick2 && <FeatherIcon icon="trash-2" />}Delete</Button>
                        </div>]) : false}
            >{displayItems ?
                <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            <BasicFormWrapper>
                                <Form style={{ width: '100%' }} form={form} name="Assignto" colon={false}>
                                    <div style={{ margin: 40 }}>
                                        <Heading as="h5">Generic Details</Heading>
                                        <Row gutter={15} style={{ marginTop: 20 }}>
                                            <Col span={8} style={{ marginBottom: 30 }}>
                                                <Form.Item label="Subject">
                                                    {detailsData?.subject}
                                                </Form.Item>
                                            </Col>
                                            {popupPage === "Approver" && <Col span={8} style={{ marginBottom: 30 }}>
                                                <Form.Item label="Requester">
                                                    <div className="user-info_image">
                                                        {detailsData.requesterId && (detailsData.requesterProfilePic !== null && detailsData.requesterProfilePic
                                                            !== undefined && detailsData.requesterProfilePic !== "" ?
                                                            <figure>
                                                                <img style={{ width: "30px", height: "30px" }} src={detailsData.requesterProfilePic} alt="" />
                                                            </figure>
                                                            :
                                                            <span className='list_span_Tag UserIcon'>
                                                                {detailsData?.requesterFirstName?.slice(0, 1).toUpperCase()}
                                                            </span>)
                                                        }
                                                        {detailsData.requesterId &&
                                                            <figcaption>
                                                                <div>
                                                                    {`${detailsData?.requesterFirstName} ${detailsData?.requesterLastName}`}
                                                                </div>
                                                                <div className='entityemail'>
                                                                    {detailsData?.requesterEmail}
                                                                </div>
                                                            </figcaption>}
                                                    </div>
                                                </Form.Item>
                                            </Col>}
                                            <Col span={8} style={{ marginBottom: 30 }}>
                                                <Form.Item label="Status">
                                                    < div className={`status-text ApprovalStatus-${popupPage === "Approver" ? approverStatus?.approvalStatus : detailsData?.status}`}>{popupPage === "Approver" ? approverStatus?.approvalStatus : detailsData?.status}</div >
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={30} style={{ marginBottom: 20 }}>
                                            <Col span={12} style={{ marginBottom: 20 }}>
                                                <Form.Item label="Approval Status">
                                                    {acceptList?.map((item, index) => (
                                                        <div key={index} style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                                            {item.approvalStage}.
                                                            <div className='Div_flex'>
                                                                <div className='share_image' title={`${item.approvers} (${item.approvalStatus})`} style={{ cursor: "default" }}>
                                                                    <span className="image_icon2 UserIcon">
                                                                        {item?.approvers?.slice(0, 1).toUpperCase()}
                                                                    </span>
                                                                    <span>{`${item?.approvers.substring(0, 10)}...`}</span>
                                                                    <FeatherIcon icon={item.approvalStatus === "Approved" ? "thumbs-up" :
                                                                        item.approvalStatus === "Rejected" ? "thumbs-down" : "smile"}
                                                                        style={{
                                                                            color: item.approvalStatus === "Approved" ? "green" :
                                                                                item.approvalStatus === "Rejected" ? "red" : "gray"
                                                                        }}
                                                                        size={15} className="Svg" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </Form.Item>
                                            </Col>
                                            <Col span={12} style={{ marginBottom: 20 }}>
                                                <Form.Item label="Pending with">
                                                    {pendingList?.map((item, index) => {
                                                        const approverArray = item.approvers.includes('/')
                                                            ? item.approvers.split('/')
                                                            : [item.approvers];
                                                        return (
                                                            <div key={index} style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                                                {detailsData?.is_approves === 0 && !detailsData?.if_approve_no?.isResposeRequired ? "" : `${item.approvalStage}.`}
                                                                <div
                                                                    className="approver-wrap"
                                                                    style={{
                                                                        display: "flex",
                                                                        flexWrap: "wrap", // allows wrapping
                                                                        gap: "8px",
                                                                        marginTop: "4px"
                                                                    }}
                                                                >
                                                                    {approverArray.map((approver, i) => (
                                                                        <div className='Div_flex' style={{ margin: 0, gap: 5 }}>
                                                                            <div
                                                                                key={i}
                                                                                className='share_image'
                                                                                title={`${approver} (Pending)`}
                                                                                style={{ cursor: "default" }}
                                                                            >
                                                                                <span className="image_icon2 UserIcon">
                                                                                    {approver.trim().charAt(0).toUpperCase()}
                                                                                </span>
                                                                                <span>{approver?.length > 10 ? `${approver.trim().substring(0, 10)}...` : approver}</span>
                                                                                <FeatherIcon
                                                                                    icon="clock"
                                                                                    style={{ color: "orange" }}
                                                                                    size={15}
                                                                                    className="Svg"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                    {/* {
                                                        pendingList?.map((item, index) => (
                                                            <div key={index}>
                                                                {item.approvalStage}. {item.approvers}
                                                            </div>
                                                        ))
                                                    } */}
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Heading as="h5">Request Details</Heading>
                                        <Row gutter={15} style={{ marginTop: 25 }}>
                                            <Col span={8} style={{ marginBottom: 30 }}>
                                                <Form.Item label={`${detailsData?.entityType} Name`}>
                                                    {detailsData?.entityAction === "Created" ?
                                                        <div className="user-info_image">
                                                            {detailsData?.entityType === "Lead" && (
                                                                <>
                                                                    {(detailsData?.entityData?.leadProfile !== null && detailsData?.entityData?.leadProfile !== undefined && detailsData?.entityData?.leadProfile !== "" ?
                                                                        <figure>
                                                                            <img style={{ width: "30px", height: "30px" }} src={detailsData?.entityData?.leadProfile} alt="" />
                                                                        </figure> :
                                                                        <span className="list_span_Tag LeadIcon">
                                                                            {detailsData?.entityData?.firstName?.slice(0, 1).toUpperCase()}
                                                                        </span>)}
                                                                    < figcaption >
                                                                        <div>
                                                                            {detailsData?.entityData?.firstName} {detailsData?.entityData?.lastName}
                                                                        </div>
                                                                        <div className='entityemail'>
                                                                            {detailsData?.entityData?.primaryEmail}
                                                                        </div>
                                                                    </figcaption>
                                                                </>)}
                                                            {detailsData?.entityType === "Contact" && (
                                                                <>
                                                                    {(detailsData?.entityData?.contactProfile !== null && detailsData?.entityData?.contactProfile !== undefined && detailsData?.entityData?.contactProfile !== "" ?
                                                                        <figure>
                                                                            <img style={{ width: "30px", height: "30px" }} src={detailsData?.entityData?.contactProfile} alt="" />
                                                                        </figure> :
                                                                        <span className="list_span_Tag ContactIcon">
                                                                            {detailsData?.entityData?.firstName?.slice(0, 1).toUpperCase()}
                                                                        </span>)}
                                                                    < figcaption >
                                                                        <div>
                                                                            {detailsData?.entityData?.firstName} {detailsData?.entityData?.lastName}
                                                                        </div>
                                                                        <div className='entityemail'>
                                                                            {detailsData?.entityData?.email}
                                                                        </div>
                                                                    </figcaption>
                                                                </>)}
                                                            {detailsData?.entityType === "Account" && (
                                                                <>
                                                                    {(detailsData?.entityData?.accountProfile !== null && detailsData?.entityData?.accountProfile !== undefined && detailsData?.entityData?.accountProfile !== "" ?
                                                                        <figure>
                                                                            <img style={{ width: "30px", height: "30px" }} src={detailsData?.entityData?.accountProfile} alt="" />
                                                                        </figure> :
                                                                        <span className="list_span_Tag AccountIcon">
                                                                            {detailsData?.entityData?.accountName?.slice(0, 1).toUpperCase()}
                                                                        </span>)}
                                                                    < figcaption >
                                                                        <div>
                                                                            {detailsData?.entityData?.accountName}
                                                                        </div>
                                                                        <div className='entityemail'>
                                                                            {detailsData?.entityData?.accountNumber}
                                                                        </div>
                                                                    </figcaption>
                                                                </>)}
                                                            {detailsData?.entityType === "Deal" && (
                                                                <>
                                                                    {(detailsData?.entityData?.dealProfile !== null && detailsData?.entityData?.dealProfile !== undefined && detailsData?.entityData?.dealProfile !== "" ?
                                                                        <figure>
                                                                            <img style={{ width: "30px", height: "30px" }} src={detailsData?.entityData?.dealProfile} alt="" />
                                                                        </figure> :
                                                                        <span className="list_span_Tag DealIcon">
                                                                            {detailsData?.entityData?.dealName?.slice(0, 1).toUpperCase()}
                                                                        </span>)}
                                                                    < figcaption >
                                                                        <div>
                                                                            {detailsData?.entityData?.dealName}
                                                                        </div>
                                                                        {/* <div className='entityemail'>
                                                                            {detailsData?.entityData?.primaryEmail}
                                                                        </div> */}
                                                                    </figcaption>
                                                                </>)}
                                                        </div>
                                                        :
                                                        <div className="user-info_image">
                                                            {detailsData?.entityType === "Lead" && (
                                                                <>
                                                                    {(entityData?.leadProfile !== null && entityData?.leadProfile !== undefined && entityData?.leadProfile !== "" ?
                                                                        <figure>
                                                                            <img style={{ width: "30px", height: "30px" }} src={entityData?.leadProfile} alt="" />
                                                                        </figure> :
                                                                        <span className="list_span_Tag LeadIcon">
                                                                            {entityData?.firstName?.slice(0, 1).toUpperCase()}
                                                                        </span>)}
                                                                    < figcaption >
                                                                        <div>
                                                                            {entityData?.firstName} {entityData?.lastName}
                                                                        </div>
                                                                        <div className='entityemail'>
                                                                            {entityData?.primaryEmail}
                                                                        </div>
                                                                    </figcaption>
                                                                </>)}
                                                            {detailsData?.entityType === "Contact" && (
                                                                <>
                                                                    {(entityData?.contactProfile !== null && entityData?.contactProfile !== undefined && entityData?.contactProfile !== "" ?
                                                                        <figure>
                                                                            <img style={{ width: "30px", height: "30px" }} src={entityData?.contactProfile} alt="" />
                                                                        </figure> :
                                                                        <span className="list_span_Tag ContactIcon">
                                                                            {entityData?.firstName?.slice(0, 1).toUpperCase()}
                                                                        </span>)}
                                                                    < figcaption >
                                                                        <div>
                                                                            {entityData?.firstName} {entityData?.lastName}
                                                                        </div>
                                                                        <div className='entityemail'>
                                                                            {entityData?.email}
                                                                        </div>
                                                                    </figcaption>
                                                                </>)}
                                                            {detailsData?.entityType === "Account" && (
                                                                <>
                                                                    {(entityData?.accountProfile !== null && entityData?.accountProfile !== undefined && entityData?.accountProfile !== "" ?
                                                                        <figure>
                                                                            <img style={{ width: "30px", height: "30px" }} src={entityData?.accountProfile} alt="" />
                                                                        </figure> :
                                                                        <span className="list_span_Tag AccountIcon">
                                                                            {entityData?.accountName?.slice(0, 1).toUpperCase()}
                                                                        </span>)}
                                                                    < figcaption >
                                                                        <div>
                                                                            {entityData?.accountName}
                                                                        </div>
                                                                        <div className='entityemail'>
                                                                            {entityData?.accountNumber}
                                                                        </div>
                                                                    </figcaption>
                                                                </>)}
                                                            {detailsData?.entityType === "Deal" && (
                                                                <>
                                                                    {(entityData?.dealProfile !== null && entityData?.dealProfile !== undefined && entityData?.dealProfile !== "" ?
                                                                        <figure>
                                                                            <img style={{ width: "30px", height: "30px" }} src={entityData?.dealProfile} alt="" />
                                                                        </figure> :
                                                                        <span className="list_span_Tag DealIcon">
                                                                            {entityData?.dealName?.slice(0, 1).toUpperCase()}
                                                                        </span>)}
                                                                    < figcaption >
                                                                        <div>
                                                                            {entityData?.dealName}
                                                                        </div>
                                                                        {/* <div className='entityemail'>
                                                                            {entityData?.primaryEmail}
                                                                        </div> */}
                                                                    </figcaption>
                                                                </>)}
                                                        </div>
                                                    }
                                                </Form.Item>
                                            </Col>
                                            <Col span={8} style={{ marginBottom: 30 }}>
                                                <Form.Item label="Record Action">
                                                    {detailsData?.entityAction}
                                                </Form.Item>
                                            </Col>
                                            <Col span={8} style={{ marginBottom: 30 }}>
                                                <Form.Item label="Due Date">
                                                    {detailsData?.dueDate && profile.dateFormate ? moment(detailsData?.dueDate).format(profile.dateFormate) : (detailsData?.dueDate && moment(detailsData?.dueDate).format("YYYY-MM-DD"))}
                                                </Form.Item>
                                            </Col>
                                            <Col span={24} style={{ marginBottom: 38 }}>
                                                <Form.Item label="Condition">
                                                    {detailsData?.approvalQuery}
                                                </Form.Item>
                                            </Col>
                                            {detailsData?.entityAction === "Edited" && <>
                                                <Col span={12} style={{ marginBottom: 38 }}>
                                                    <Form.Item label="Current Data">
                                                        {currentData?.map((item, index) => (
                                                            <div key={index}>
                                                                {item.fieldLable} : {(item.fieldLable === "Win Probability" || item.fieldLable === "Expected Deal Margin" || item.fieldLable === "Discount Percentage" || item.fieldLable === "Actual Deal Margin") ? `${item.attributevalue} %` : item.attributevalue}
                                                            </div>))}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12} style={{ marginBottom: 38 }}>
                                                    <Form.Item label="Proposed Change">
                                                        {proposedData?.map((item, index) => (
                                                            <div key={index}>
                                                                {item.fieldLable} : {(item.fieldLable === "Win Probability" || item.fieldLable === "Expected Deal Margin" || item.fieldLable === "Discount Percentage" || item.fieldLable === "Actual Deal Margin") ? `${item.attributevalue} %` : item.attributevalue}
                                                            </div>))}
                                                    </Form.Item>
                                                </Col>
                                            </>}
                                            {detailsData?.entityAction === "Created" && <>
                                                <Col span={12} style={{ marginBottom: 38 }}>
                                                    <Form.Item label="Current Data">
                                                        {currentData?.map((item, index) => (
                                                            <div key={index}>
                                                                {item.fieldLable} : {(item.fieldLable === "Win Probability" || item.fieldLable === "Expected Deal Margin" || item.fieldLable === "Discount Percentage" || item.fieldLable === "Actual Deal Margin") ? `${item.attributevalue} %` : item.attributevalue}
                                                            </div>))}
                                                    </Form.Item>
                                                </Col> </>}
                                            <Col span={24} style={{ marginBottom: 30 }}>
                                                <Form.Item label="Description">
                                                    {detailsData?.discription}
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item label="Comments" />
                                                {popupPage === "Approver" ?
                                                    (approverStatus?.approvalStatus === "Approved" || approverStatus?.approvalStatus === "Rejected") ? "" :
                                                        <div style={{ position: 'relative', width: '100%' }}>
                                                            <Input.TextArea
                                                                placeholder="Enter Comments"
                                                                rows={2}
                                                                value={notes}
                                                                onChange={(e) => {
                                                                    const inputValue = e.target.value;
                                                                    const error = validateDescriptionField(inputValue, 2500);
                                                                    if (error) {
                                                                        message.error(error);
                                                                        return;
                                                                    }
                                                                    setNotes(inputValue);
                                                                }}
                                                                style={{ paddingRight: '100px' }}
                                                            />
                                                            <Button
                                                                disabled={notes === null || notes === undefined || notes === ''}
                                                                className="button_colors"
                                                                onClick={handleAddNote}
                                                                style={{ position: 'absolute', right: '20px', bottom: '5px' }}
                                                            >
                                                                Add
                                                            </Button>
                                                        </div> : ""}
                                                {allNotes?.length > 0 ?
                                                    <div>
                                                        {allNotes &&
                                                            allNotes.map((note, index) => {
                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        className="cnote-card"
                                                                        style={{
                                                                            backgroundColor: '#F5F5F7',
                                                                            color: '#134B70',
                                                                            padding: 10,
                                                                            borderRadius: 5,
                                                                            marginTop: 10,
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                display: 'flex',
                                                                                gap: 10,
                                                                                justifyContent: 'space-between',
                                                                            }}
                                                                        >
                                                                            <p style={{ fontSize: 12 }}>{note.name}</p>
                                                                            <div style={{ fontSize: 12, gap: 10, display: "flex", alignItems: "center" }}>
                                                                                <p>{convertAndFormatDateTime2(note.time, companyProfile, profile)}</p>
                                                                                {(profile.userId === note.id && popupPage === "Approver" && approverStatus?.approvalStatus !== "Approved" && approverStatus?.approvalStatus !== "Rejected") &&
                                                                                    <p className="cdelete-icon"><FeatherIcon icon="trash-2" size={16} style={{ color: "red", cursor: "pointer" }} onClick={() => NoteDelete(index)} /></p>}
                                                                            </div>
                                                                        </div>
                                                                        <p>{note.content}</p>
                                                                    </div>
                                                                );
                                                            })}
                                                    </div> :
                                                    <></>
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                </Form>
                            </BasicFormWrapper>
                        </div>
                    </AddUser>
                </Scrollbars> :
                <div className="spin">
                    <Spin />
                </div>}
            </Drawer >
            {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} GetCallback={deleteMenu} deleteId={deleteId} page="Notes" />}
        </>
    );
};

Popup.propTypes = {
    popup: PropTypes.bool.isRequired,
    setPopup: PropTypes.func.isRequired,
    popupId: PropTypes.number.isRequired,
    currencySettingsRef: PropTypes.object.isRequired,
    detailsId: PropTypes.number.isRequired,
    setPopupId: PropTypes.func.isRequired,
    popupPage: PropTypes.string.isRequired,
    setPopupPage: PropTypes.func.isRequired,
    MyList: PropTypes.func.isRequired,
    SharedList: PropTypes.func.isRequired,
};

export default Popup;